import * as React from 'react';

import { Spinner } from '~shared/components/Spinner/Spinner';
import { PageNotFound } from '~teacher/components/NotFound';
import { useGetWorkspaceQuiz } from '~teacher/hook/workspaces/useGetWorkspaceQuiz';

import { WorkspaceQuizEditor } from './WorkspaceQuizEditor';

interface Props {
  workspaceQuizId: string;
  workspaceId: string;
}

export function WorkspaceQuiz({ workspaceId, workspaceQuizId }: Props) {
  const workspaceQuizQuery = useGetWorkspaceQuiz({
    workspaceQuizId,
    workspaceId,
  });

  if (workspaceQuizQuery.isSuccess) {
    const {
      workspaceId,
      id: workspaceQuizId,
      quiz,
      parentFolderId,
      deletedDate,
    } = workspaceQuizQuery.data;
    return (
      <WorkspaceQuizEditor
        {...{
          workspaceId,
          workspaceQuizId,
          quiz: { ...quiz, deleted: deletedDate !== null },
          parentFolderId,
        }}
      />
    );
  }

  if (workspaceQuizQuery.isError) {
    return <PageNotFound />;
  }

  return (
    <div className="my-12 mx-auto">
      <Spinner />
    </div>
  );
}
